import React from 'react';
import { Route, Switch } from 'react-router-dom';
import BlackList from '../../pages/emails/Blacklist';

export const EmailRouter = ({ match }) => {
    const { path } = match;
    return (
        <Switch>
            <Route exact path={`${path}/blacklist`} render={() => <BlackList />} />
        </Switch>
    );
};
